import React, {
  // useState,
  // useRef,
  // useEffect,
  // useMemo,
  useCallback,
} from "react";
import AjaxHooks from "../AjaxHooks";
// import Hw3ListContainer from "../Hw3ListContainer"; 
import Hw3ListContainer from "./Hw3ListContainer"; 
import { Link } from 'react-router-dom';

const Hw3 = () => {

  // const add = useCallback((e) => {
  //   console.log("add"); 
  //   // gridRef.current.api.deselectAll();
  // }, []);


  return (
    <div>
      <div>
        {/* <button onClick={add}>Add New</button> */}
        <Link to={`/addItem/`}> <p>AddItem</p> </Link>
        <Link to={`/AddFile/`}> <p>AddFile</p> </Link>
      </div>
      <ul className="hw3Grid-container">
        <Hw3ListContainer />
     </ul>
     <ul className="iotGrid-container">
        <AjaxHooks />
     </ul>
    </div>
  );
};

//  render(<Hw2></Hw2>, document.querySelector('#root'));
export default Hw3;
